import { useState } from "react";
import { runStorageCheck, drawingsConfigured } from "../utils/blobStorage";

// "Test drawing storage" — a one-click end-to-end check of the private drawings container, run as the signed-in user:
// build setting -> Azure Storage sign-in -> write -> read back -> delete. Each step is reported in plain words so a
// missing setting (build value, consent, role, CORS) is named before anyone tries to upload a plan set.

export default function DrawingStorageCheck() {
  const [running, setRunning] = useState(false);
  const [steps, setSteps] = useState(null);

  async function run() {
    setRunning(true); setSteps(null);
    try { setSteps(await runStorageCheck()); }
    catch (e) { setSteps([{ key: "error", label: "The check could not run", ok: false, detail: e.message || String(e) }]); }
    finally { setRunning(false); }
  }

  const allOk = steps && steps.length >= 5 && steps.every(s => s.ok);
  return (
    <div style={{ marginTop: 28 }} data-testid="drawing-storage-check">
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4 }}>Drawing storage</div>
      <div style={{ fontSize: 12, color: "var(--text3)", marginBottom: 10 }}>
        Checks the private drawings container as you: writes a tiny test file, reads it back and deletes it.
        {!drawingsConfigured() && <span style={{ color: "#b45309" }}> Not configured in this build yet.</span>}
      </div>
      <button onClick={run} disabled={running}
        style={{ padding: "6px 14px", fontSize: 12, fontWeight: 600, background: "#0ea5e9", color: "#fff", border: "none", borderRadius: 6, cursor: running ? "wait" : "pointer", opacity: running ? 0.7 : 1 }}>
        {running ? "Testing…" : "Test drawing storage"}
      </button>
      {steps && (
        <div role="status" style={{ marginTop: 12, border: "1px solid var(--cs-border)", borderRadius: 8, padding: "8px 12px", maxWidth: 640 }}>
          {steps.map(s => (
            <div key={s.key} style={{ padding: "4px 0", fontSize: 12.5 }}>
              <span style={{ color: s.ok ? "#15803d" : "#dc2626", fontWeight: 700 }}>{s.ok ? "✓" : "✗"}</span> {s.label}
              {!s.ok && s.detail && <div style={{ marginLeft: 18, color: "#b91c1c", fontSize: 12 }}>{s.detail}</div>}
            </div>
          ))}
          {allOk && <div style={{ marginTop: 6, fontWeight: 700, color: "#15803d", fontSize: 12.5 }}>Drawing storage works for you.</div>}
        </div>
      )}
    </div>
  );
}
